import React from "react";
import styled from "styled-components/macro";
import { Link } from "react-router-dom";
import { ErrorBoundaryPage } from "components/common/error";
import { BigButtonLink } from "components/common/buttons";
import { FormContainer, AuthContainer } from "components/common/container";
import { AuthBranding as Branding } from "components/common/branding";

const InfoContainer = styled(FormContainer)`
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  text-align: center;
`;

const Title = styled.h1`
  text-align: center;
  color: ${(props) => props.theme.colors.primary};
  font-size: 2.4rem;
  margin: 4rem 2rem;
`;

export const LogoutButton = styled(Link)`
  position: fixed;
  top: 2rem;
  right: 2rem;
  border: none;
  background: inherit;
  font-size: 1rem;
  color: ${(props) => props.theme.colors.colorWhite};
`;

function NotFound() {
  return (
    <ErrorBoundaryPage text="Not Found">
      <Branding />
      <AuthContainer>
        <InfoContainer>
          <Title>Page Not Found</Title>
          <BigButtonLink $coral to="/">
            Back To Dashboard
          </BigButtonLink>
        </InfoContainer>
      </AuthContainer>
      <LogoutButton to="/logout">Logout</LogoutButton>
    </ErrorBoundaryPage>
  );
}

export default NotFound;
